module.exports = __webpack_public_path__ + "static/media/Geomanist-Medium.710cedaf.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Geomanist/Web/Geomanist-Medium.ttf
// module id = 518
// module chunks = 1